/**
 * Coure.Hub.PlatformFee
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreatePlatformFeeRequestDto } from '../model/createPlatformFeeRequestDto';
import { HubPlatformFee } from '../model/hubPlatformFee';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PlatformFeeService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformFeeCreatePlatformFeePost(body?: CreatePlatformFeeRequestDto, observe?: 'body', reportProgress?: boolean): Observable<HubPlatformFee>;
    public apiPlatformFeeCreatePlatformFeePost(body?: CreatePlatformFeeRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPlatformFee>>;
    public apiPlatformFeeCreatePlatformFeePost(body?: CreatePlatformFeeRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPlatformFee>>;
    public apiPlatformFeeCreatePlatformFeePost(body?: CreatePlatformFeeRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<HubPlatformFee>('post',`${this.basePath}/api/PlatformFee/CreatePlatformFee`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param feeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformFeeDeletePlatformFeeFeeIdDelete(feeId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiPlatformFeeDeletePlatformFeeFeeIdDelete(feeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiPlatformFeeDeletePlatformFeeFeeIdDelete(feeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiPlatformFeeDeletePlatformFeeFeeIdDelete(feeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (feeId === null || feeId === undefined) {
            throw new Error('Required parameter feeId was null or undefined when calling apiPlatformFeeDeletePlatformFeeFeeIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('delete',`${this.basePath}/api/PlatformFee/DeletePlatformFee/${encodeURIComponent(String(feeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformFeeGetAllPlatformFeeGet(observe?: 'body', reportProgress?: boolean): Observable<Array<HubPlatformFee>>;
    public apiPlatformFeeGetAllPlatformFeeGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubPlatformFee>>>;
    public apiPlatformFeeGetAllPlatformFeeGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubPlatformFee>>>;
    public apiPlatformFeeGetAllPlatformFeeGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubPlatformFee>>('get',`${this.basePath}/api/PlatformFee/GetAllPlatformFee`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param feeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformFeeGetPlatformFeeByFeeIdFeeIdGet(feeId: string, observe?: 'body', reportProgress?: boolean): Observable<HubPlatformFee>;
    public apiPlatformFeeGetPlatformFeeByFeeIdFeeIdGet(feeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPlatformFee>>;
    public apiPlatformFeeGetPlatformFeeByFeeIdFeeIdGet(feeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPlatformFee>>;
    public apiPlatformFeeGetPlatformFeeByFeeIdFeeIdGet(feeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (feeId === null || feeId === undefined) {
            throw new Error('Required parameter feeId was null or undefined when calling apiPlatformFeeGetPlatformFeeByFeeIdFeeIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<HubPlatformFee>('get',`${this.basePath}/api/PlatformFee/GetPlatformFeeByFeeId/${encodeURIComponent(String(feeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformFeeGetPlatformFeeByUserIdUserIdGet(userId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<HubPlatformFee>>;
    public apiPlatformFeeGetPlatformFeeByUserIdUserIdGet(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HubPlatformFee>>>;
    public apiPlatformFeeGetPlatformFeeByUserIdUserIdGet(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HubPlatformFee>>>;
    public apiPlatformFeeGetPlatformFeeByUserIdUserIdGet(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling apiPlatformFeeGetPlatformFeeByUserIdUserIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HubPlatformFee>>('get',`${this.basePath}/api/PlatformFee/GetPlatformFeeByUserId/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
